import { observable, action, makeObservable } from 'mobx';
import { AffordabilityExcludedState } from 'src/AppState/AffordabilityExcludedState';

export class AffordabilityExcludedRequestsRowState {
    @observable public showMore: boolean = false;
    @observable public particularAction: boolean = false;

    public constructor(
        private readonly affordabilityExcludedState: AffordabilityExcludedState,
        private readonly accountId: number
    ) {
        makeObservable(this);
    }

    @action public toggleShowMore = (): void => {
        this.showMore = !this.showMore;
    };

    @action public toggleParticularAction = (): void => {
        this.particularAction = !this.particularAction;
    };

    @action public closeParticularAction = (clickOutside: boolean): void => {
        if (clickOutside === true) {
            this.particularAction = false;
        }
    };

    public handleCheckOne = async (): Promise<void> => {
        await this.affordabilityExcludedState.handleCheckOne(this.accountId);
    };
}
